import React from 'react'
import { List, ListItem, ListItemText } from '@mui/material'
import { map } from 'lodash'
import PropTypes from 'prop-types'

function PaintworkList({ items }) {
  return (
    <List
      sx={{
        pl: 2,
        '&:before': {
          position: 'absolute',
          top: 8,
          left: 0,
          bottom: 8,
          display: 'block',
          content: '" "',
          height: 'calc(100% - 16px)',
          width: 12,
          background:
            'linear-gradient(180deg, #19BF0A 0%, #F1F512 34.76%, #F85C04 66.05%, #DA0000 100%)',
        },
      }}
    >
      {map(items, ({ title, subtitle }, key) => (
        <ListItem key={key} disablePadding>
          <ListItemText
            primary={title}
            primaryTypographyProps={{ variant: 'body2' }}
            secondary={subtitle}
            secondaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
      ))}
    </List>
  )
}

PaintworkList.propTypes = {
  items: PropTypes.array,
}
PaintworkList.defaultProps = {
  items: [],
}

export default PaintworkList
